import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ParadigmaModal from "../../components/ParadigmaModal/ParadigmaModal.js";
import ParadigmaLabeledInput from "../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"
import api from "../../api";

class ModalLotes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            manzana: '',
            numero: 0,
            patchVariables: [
                'manzana',
                'numero'
            ],
            errors: {}
        }
    }

    static propTypes = {
        onSubmit: PropTypes.func,
        id: PropTypes.func,
        action: PropTypes.oneOf(['EDIT', 'DETAIL']).isRequired,
    }

    resetForm() {
        this.setState({
            manzana: '',
            numero: 0,
            errors: {},
        });
    }

    getData() {
        const { patchVariables } = this.state;
        let data = {};
        patchVariables.forEach(x => {
            data[x] = this.state[x];
        });
        return data;
    }

    setData(data) {
        if (data.success) {
            this.setState({
                manzana: data.manzana,
                numero: data.numero,
            });
        }
    }

    setErrors(errors) {
        this.setState({ errors });
    }

    onChangeField(field, value) {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
        else return null;
    }
    
    modalVars() {
        const { action } = this.props;
        if (action == "EDIT") {
            return {
                get: true,
                submitType: "PATCH",
                title: "Editar Lotes",
                buttonTitle: "Editar",
                danger: false,
                buttonIcon: "fa fa-pencil fa-lg",
                successMessage: "El Lote ha sido editado con éxito.",
                saveButton: true,
                buttonClass: "",
                disabled: false,
                id: this.props.id,
            };
        } else if (action == "DETAIL") {
            return {
                get: true,
                submitType: "",
                title: "Lote",
                buttonTitle: "Ver",
                danger: false,
                buttonIcon: "fa fa-search fa-lg",
                successMessage: "",
                saveButton: false,
                buttonClass: "",
                disabled: true,
                id: this.props.id,
            };
        }
    }

    render() {
        const vars = this.modalVars();
        const fieldClassNames = ["ui-field-label-col", "ui-field-control-col"];
        return (
            <ParadigmaModal
                getUrl={(vars.get ? api.loteos.lote.replace('$id_loteo', this.props.loteoId) : null)}
                submitUrl={(vars.submitType ? api.loteos.lote.replace('$id_loteo', this.props.loteoId) : null)}
                submitType={vars.submitType}
                id={vars.id}

                onGotData={(data) => this.setData(data)}
                onGotErrors={(errors) => this.setErrors(errors)}
                onSubmit={(e) => this.props.onSubmit(e)}
                onClose={() => this.resetForm()}
                onPreSubmit={() => this.getData()}

                title={vars.title}

                danger={vars.danger}
                buttonClass={vars.buttonClass}

                successMessage={vars.successMessage}
                missingIdMessage={"Debe seleccionar una fila."}

                buttonTitle={vars.buttonTitle}
                buttonIcon={vars.buttonIcon}
                saveButton={vars.saveButton}
                saveButtonLabel={vars.saveButtonLabel}
                closeButton={true}
                className="ui-paradigma-modal"
            >
                <section className="ui-modal-section">
                    <p className="ui-section-label">Datos del lote</p>
                    <div className="ui-form-grid">
                        <ParadigmaLabeledInput
                            disabled={vars.disabled}
                            md={[12, 12]}
                            classNames={fieldClassNames}
                            label={"Manzana"}
                            maxLength={30}
                            value={this.state.manzana}
                            onChange={e => this.onChangeField('manzana', e.target.value)}
                            error={() => this.getError('manzana')}
                        />
                        <ParadigmaLabeledInput
                            disabled={vars.disabled}
                            md={[12, 12]}
                            classNames={fieldClassNames}
                            label={"Número"}
                            value={this.state.numero}
                            onChange={e => this.onChangeField('numero', e.target.value)}
                            error={() => this.getError('numero')}
                        />
                    </div>
                </section>
            </ParadigmaModal>
        );
    }

}

export default ModalLotes;



// WEBPACK FOOTER //
// ./src/views/Loteos/ModalLotes.js